<template>
    <v-container>
        <v-row>
            <v-col cols='12'>
                <v-card flat>
                    <v-card-title><span class="headline my-4">Buildings Carbon Typology Library</span></v-card-title>
                    <v-card-text>
                        <p>
                            This section is a library of common typologies and systems commonly used by different disciplines
                            on commercial projects within the Buildings sector. It is intended to help guide designers in what they should be aiming to surpass for 
                            embodied carbon (at A1-5 lifecycle stages) in the design of their projects. This library is particularly 
                            recommended for aiding discussions at the early stages of design, where decisions made over project form 
                            and materiality are likely to have the greatest influence on environmental impact.
                        </p>
                        <p>
                            To aid in this exercise, each item in this library is tagged for whether it represents good practice
                            (<v-icon color='secondary' small >mdi-chevron-left-circle-outline</v-icon>), worst case 
                            (<v-icon color='error' small >mdi-chevron-right-circle-outline</v-icon>), or baseline design 
                            (<v-icon color='tertiary' small >mdi-record-circle-outline</v-icon>), reflecting whether it's 
                            implementation across many projects would result in a trend towards less impactful projects, away from 
                            that desire, or keeping things much the same.
                        </p>
                        <p>
                            In addition, each item has been tagged by its <v-chip small color='secondary' dark>Discipline</v-chip>, 
                            <v-chip small color='primary' text-color='secondary'>Primary material</v-chip>, and 
                            <v-chip small color='tertiary' dark>Region</v-chip>. Clicking on each card will reveal details about each 
                            typology including a breakdown of carbon, assumptions used in the assessments made, and the applicability of 
                            each type.
                        </p>
                    </v-card-text>
                </v-card>
                <v-card flat>
                    <type-table-buildings />
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TypeTableBuildings from '../components/TypeTableBuildings.vue'

export default {
    components: {
        TypeTableBuildings
    },
    
}
</script>
        TypeTableBuildings